<template> 
	 <div id="solvency" class="w95mg">
			 <h5 class="endsm_title">短期偿债能力</h5>
				<div v-html="sodata.itemShort.html" class="solvencyFont"></div>
				<div class="echartbox-block flexcss" >
					<div class="echart-box" id="liudongPercent" :style="'width:'+echartWidth3+'px'"></div>
					<div class="echart-box" id="sudongPercent" :style="'width:'+echartWidth3+'px'"></div>
					<div class="echart-box" id="xianjinPercent" :style="'width:'+echartWidth3+'px'"></div> 
				</div> 
				<h5 class="endsm_title"> 长期偿债能力</h5>
				<div v-html="sodata.itemLong.html" class="solvencyFont"></div>
				<div class="echartbox-block"  >
					<div class="echart-box" id="fuzhaiEcharts" :style="'width:'+echartWidth4+'px'"></div>
				</div>
		</div>
</template>

<script>
	export default {
	  name: 'solvency', 
			data() {
				return {
					titleh:"偿债能力",
			  echartWidth3: document.body.offsetWidth * 0.8728 * 0.95 * 0.32,
			  echartWidth4: document.body.offsetWidth * 0.8728 * 0.95 * 0.6,
					// shortData:{date:[],series:[{data:[],name:"",type:""},{data:[],name:"",type:""},{data:[],name:"",type:""}]},longData:{date:[],series:[{data:[],name:"",type:""}]},
					shortData:{},longData:{},
			}},
	  props: { 
				 sodata:{},
	  }, 
			created(){ 
				
				
			},
			mounted() {
				var _this=this;
			 if(this.sodata.itemShort.json != ''){
			 var shortData=eval("(" + this.sodata.itemShort.json + ")");  
					// console.log('a',	this.shortData,this.shortData.date,this.shortData.series[0].data,this.shortData.series[0].name);
					if(shortData.date != undefined){  
							_this.linechartfun1('liudongPercent',shortData.date,shortData.series[0].data,shortData.series[0].name);
							_this.linechartfun1('sudongPercent',shortData.date,shortData.series[1].data,shortData.series[1].name);
							_this.linechartfun1('xianjinPercent',shortData.date,shortData.series[2].data,shortData.series[2].name);
					 
					} 
			 	
			 }
			 if(this.sodata.itemLong.json != ''){
					// console.log('a',	longData,longData.date,longData.series[0].data);
			 		var longData=eval ("(" + this.sodata.itemLong.json + ")"); 
							if(longData.date != undefined){ 
							console.log('y',longData)
							_this.linechartfun1('fuzhaiEcharts',longData.date,longData.series[0].data,longData.series[0].name);
					 }
			 }
			 
			 // console.log('偿债能力vue2',this.shortData );
			 // console.log('偿债能力vue3',this.longData );
			},
			methods:{
				linechartfun1(el,xdata,ydata,title,){ 
						var mylinechart = echarts.init(document.getElementById(el)); 
							var	option = {
									title: {
										text: '',
										left: 'center',
										top:10, 
									},
									color: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
									// tooltip: {
									// 	trigger: 'item'
									// },
									tooltip: {
										trigger: 'item',
										backgroundColor: 'rgba(255,255,255,0.9)',
										borderColor: '#ddd',
										borderWidth: '1',
										textStyle: {
										color: '#000',
										fontSize: 14, 
										}, 
										formatter: function(params) { 
											let rethtml = params.marker + params.name + '年'+title+"：" + params.value +'%' ;
											return rethtml;
										}
									},
									grid: {
										x:60,
										y: 60,
										x2: 30,
										y2: 40,
										show: true,
										borderWidth: 0,
									},
									legend: {  
									show:true,
									bottom:10,
									},
									label: {show: true },
								  xAxis: {
								    type: 'category',
								    data: xdata,
								  },
								  yAxis: {
								    type: 'value',
												name: title +'（%）',
								  },
								  series: [
								    {
													name:'',
								      data: ydata,
								      type: 'line',
														smooth: true
								    }
								  ]
								};
								mylinechart.setOption(option); 
				},
			}
	}
</script>

<style type="text/css" scoped> 
 #liudongPercent,
 #sudongPercent,
 #xianjinPercent {
 	width: 30%;
 	height: 400px;
 	background: #fff;
 	border: 1px solid #eee;
 }
	#fuzhaiEcharts{
		height: 400px;
		background: #fff;
		border: 1px solid #eee;
		margin:0 auto;
	}
 .solvencyFont{
		line-height: 36px;margin-bottom: 20px;
	}
	.endsm_title {
		border-left: 8px solid #3e7bfa;
		line-height: 20px;
		padding-left: 14px;
		margin: 0 0 10px;
	}
</style>